import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useAuthStore from 'store/auth';
import { PATH_ROUTES } from 'routes/path';
import MobileNav from './MobileNav';
import { cn } from 'lib/utils';
import { HIDE_NAV_PATHS, WALKTHROUGH_CHECK } from 'lib/constants';
import useDashboard from 'hooks/useDashboard';
import AppWalkthrough from 'components/AppWalkthrough';
import useWalkthrough from 'hooks/useWalkthrough';
import useTourStore from 'store/app-tour';
import SessionExpiration from './SessionExpiration';

const COOKIE_NAME = WALKTHROUGH_CHECK.SIDEMENU;

export default function MainLayout() {
  const { pathname } = useLocation();

  const isAuthenticated = useAuthStore((store) => store.isAuthenticated);
  const startSidemenu = useTourStore((store) => store.startSideMenu);
  const { isDashboard } = useDashboard();

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const onExpandToggle = () => setIsExpanded((prev) => !prev);

  const { updateStep, walkthroughSteps } = useWalkthrough();
  const onWalkthroughComplete = () => updateStep(COOKIE_NAME);

  if (!isAuthenticated) {
    return <Navigate to={PATH_ROUTES.LOGIN} replace />;
  }

  return (
    <>
      <AppWalkthrough
        steps={walkthroughSteps.dashboard}
        run={startSidemenu && isDashboard}
        onComplete={onWalkthroughComplete}
      />

      <div className='relative flex font-isidora'>
        <Sidebar isExpanded={isExpanded} onExpandToggle={onExpandToggle} />

        <div
          className={cn(
            'w-full transition-all duration-200',
            isExpanded ? 'lg:ml-64' : 'lg:ml-20'
          )}
        >
          <MobileNav />
          <Navbar isExpanded={isExpanded} />
          <main
            className={cn(
              'lg:min-h-[calc(100vh-6rem-6rem)] lg:h-[calc(100%-6rem)] lg:mt-24 relative',
              (HIDE_NAV_PATHS.includes(pathname) || isDashboard) && '!mt-0'
            )}
          >
            <Outlet />
          </main>
        </div>
      </div>

      <SessionExpiration />
    </>
  );
}
